// extracted by mini-css-extract-plugin
export default {"btnImageParent":"style_btnImageParent__aKGaT","btnBackImage":"style_btnBackImage__ALsHF","btnBackImageGlass":"style_btnBackImageGlass__tUZYT"};